import { types, actions } from './requests'
export const GETMAPPINGDATA_TYPES = {
    ...types('GETMAPPINGDATA'),
}
export const GETMAPPINGDATA_ACTIONS = {
    ...actions('GETMAPPINGDATA'),
}
